export enum PrescriptionStatusEnum {
    Liberado = 1,
    EmAberto = 2,
    NaoDispensado = 3,
    liberadoParcialmente = 4,
    NaoDispensadoParcialmente = 5,
    Suspenso = 6,
}